__webpack_require__.p = "https://igopalakrishnan.github.io/Profile/";